export const GOL = "GOL";
export const ARGOS = "ARGOS";
export const TU = "TU";
export const BANK = "BANK";
export const AFS = "AFS";
export const HABITAT = "HABITAT";
export const SAVINGCARD = "SAVINGCARD";

export const missionNames = {
  GOL: "gol",
  NECTAR: "nectar",
  MYACCOUNT: "myaccount",
  SMARTSHOP: "smartshop",
  SAVINGCARD: "savingcard",
};

export const defaultHomePage = "https://www.sainsburys.co.uk";
